import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../../my-app/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GlobalService {
  allFilters: any;
  constructor(private http: HttpClient) { }
  apiUrl = environment.apiUrl;
  defaultWhere: any = { filter: [] };
  globalFilters: any = { filter: [] };
  customFilters: any = { filter: [] };
  private filterSubject = new BehaviorSubject<any>({ filters: [] });
  filters$ = this.filterSubject.asObservable();

  private scenarioGenerationSubject = new Subject<any>();
  scenarioGeneration$ = this.scenarioGenerationSubject.asObservable();

  private resetSubject = new Subject<void>();
  reset$ = this.resetSubject.asObservable();

  private productRoadmapLoadingSubject = new BehaviorSubject<boolean>(false);
  productRoadmapLoading$ = this.productRoadmapLoadingSubject.asObservable();

  setProductRoadmapLoading(isLoading: boolean): void {
    this.productRoadmapLoadingSubject.next(isLoading);
  }

  getProductRoadmapLoading(): boolean {
    return this.productRoadmapLoadingSubject.getValue();
  }

  resetNotify() {
    this.allFilters = {};
    this.resetSubject.next();
  }

  setFilters(filters: any) {
    this.defaultWhere.filter = {
      ...filters.filter,
      ...this.customFilters.filter,
    };
    this.globalFilters = { ...filters };
    this.allFilters = this.defaultWhere;
    this.filterSubject.next(this.defaultWhere);
  }

  generateScenarios(payload: any) {
    this.scenarioGenerationSubject.next(payload);
  }

  getCurrentFilters() {
    return this.filterSubject.getValue();
  }

  getMarketSeg() {
    const payload = {
      "requestData": {
        "filter": {
          "is_active": [
            [
              "true"
            ]
          ]
        }
      },
      "responseList": [],
      "entity": "phi",
      "batchId": "test",
      "workflowId": "ABC-123",
      "endpoints":
        [
          {
            "functionName": "DropdownMarketSegmentRead",
            "version": "1.0"
          }
        ],
      "communicationType": "rest",
      "version": "1.0"
    }
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }
  getEngineModel(marketSeg: string[]) {
    const payload = {
      "requestData": {
        "filter": {
          "is_active": [
            [
              "true"
            ]
          ],
          "cleaned_vertical": [
            marketSeg
          ]
        }
      },
      "responseList": [],
      "entity": "phi",
      "batchId": "test",
      "workflowId": "ABC-123",
      "endpoints": [
        {
          "functionName": "DropdownEngineModelRead",
          "version": "1.0"
        }
      ],
      "communicationType": "rest",
      "version": "1.0"
    }
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }
  getYear() {
    const payload = {
      requestData: {
        filter: {
          masterfilter: [['Include']],
        },
      },
      responseList: [],
      entity: 'phi',
      batchId: 'test',
      workflowId: 'ABC-123',
      endpoints: [
        {
          functionName: 'YearDropDownReadService',
          version: '1.0',
        },
      ],
      communicationType: 'rest',
      version: '1.0',
    };
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }
  updateFilterSelection(
    newFilters: { [key: string]: any[] } = {},
    widgetId?: string
  ): void {
    // Ensure base filter objects exist
    const existingFilters = this.allFilters?.filter || {};
    const mergedFilters: any = { ...existingFilters };

    // Merge new filters into existing ones
    Object.keys(newFilters).forEach((key) => {
      const values = newFilters[key];

      if (values && values.length > 0) {
        mergedFilters[key] = values;
      } else {
        // If empty, remove the filter key
        delete mergedFilters[key];
      }
    });

    // Update both local filter holders
    this.customFilters.filter = mergedFilters;
    this.allFilters = { ...this.allFilters, filter: mergedFilters };

    // Emit final payload
    const payload = {
      filter: mergedFilters,
      widgetId,
    };

    this.filterSubject.next(payload);
  }

  getAllFilters() {
    return this.allFilters;
  }
  resetFilterSelection(empty = false, reset = false): void {
    if (reset) {
      const { cleaned_vertical, final_em, new_year, ecosystem_active_year, ...remainingFilters } =
        this.customFilters.filter;

      this.customFilters = {
        ...this.customFilters,
        filter: { ...remainingFilters },
      };
      this.defaultWhere = { filter: [] };
      this.globalFilters = { filter: [] };
    }

    if (empty) {
      this.customFilters = { filter: [] };
    }
    const filtersToSend = empty ? this.globalFilters : this.customFilters;
    this.allFilters = filtersToSend;
    this.filterSubject.next({
      ...filtersToSend,
      widgetId: '',
    });
  }
}
